module.exports = __webpack_public_path__ + "img/tickets.6b633b9a.png";